/**
 * @generated SignedSource<<612a07c0239e07e6a91c296e10a20b2c>>
 * @relayHash 895c49531c4acd2c89117cc5856179da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f9f5506d7c489bd39b5842ebcf6d9e7412bc90145a136db0fb71a5873730be1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessListEmbedQuery } from './src_jiraBusinessListEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessListEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2f9f5506d7c489bd39b5842ebcf6d9e7412bc90145a136db0fb71a5873730be1",
    "metadata": {},
    "name": "src_jiraBusinessListEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
